const FB_SDK_SCRIPT_ID = "facebook-jssdk";
const FB_SDK_SRC = "https://connect.facebook.net/en_US/sdk.js";

/** Injects the Facebook SDK once (safe if Settings and Ads both load it). */
export const loadFbSdk = () => {
  if (document.getElementById(FB_SDK_SCRIPT_ID)) {
    return;
  }
  const script = document.createElement("script");
  script.id = FB_SDK_SCRIPT_ID;
  script.src = FB_SDK_SRC;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

/** Most specific tokens first — `CREATING_AD` must not match before `CREATING_AD_CREATIVE`. */
const PUBLISH_STATUS_LABELS: ReadonlyArray<readonly [token: string, label: string]> =
  [
    ["EVALUATED_PUBLISH_PLAN", "Planning update"],
    ["REUSING_CAMPAIGN", "Reusing campaign"],
    ["REUSING_ADSET", "Reusing ad set"],
    ["CREATING_PAGE_LOOKALIKE_AUDIENCE", "Creating lookalike audience"],
    ["CREATING_PAGE_ENGAGERS_AUDIENCE", "Creating engagers audience"],
    ["CREATING_AD_CREATIVE", "Creating ad creative"],
    ["REUSING_AD_CREATIVE", "Reusing ad creative"],
    ["CREATING_KYD_AUDIENCE", "Creating audience"],
    ["CREATING_CUSTOM_AUDIENCE", "Creating custom audience"],
    ["CREATING_CSV_AUDIENCE", "Importing audience"],
    ["POPULATING_AUDIENCE", "Populating audience"],
    ["PUBLISHING_CAMPAIGN", "Publishing campaign"],
    ["PUBLISHING_ADSET", "Publishing ad set"],
    ["CREATING_CAMPAIGN", "Creating campaign"],
    ["UPDATING_CAMPAIGN", "Updating campaign"],
    ["CREATING_ADSET", "Creating ad set"],
    ["UPDATING_ADSET", "Updating ad set"],
    ["CREATING_AD", "Creating ad"],
    ["UPDATING_AD", "Updating ad"],
  ];

/** User-facing publish progress line from Step Functions `update_status`. */
export function publishLoadingLabel(message: string): string | null {
  if (!message?.trim()) {
    return null;
  }
  const token = message.trim().toUpperCase();
  for (const [needle, label] of PUBLISH_STATUS_LABELS) {
    if (token.includes(needle)) {
      return label;
    }
  }
  return message.trim();
}

/** @deprecated Prefer {@link publishLoadingLabel}; kept for existing call sites. */
export const loadingMessageToText = (message: string) =>
  publishLoadingLabel(message);
